<template>
  <section>
    <div class="row col-md-12">
      <div class="form-group">
        <div :class="searchClass">
          <div class="input-group input-group-lg">
      <span class="input-group-addon" id="basic-addon1">
        <span class="glyphicons"
              :class="[loading ? 'glyphicons-refresh glyphicons-refresh-animate' : 'glyphicons-search']"></span>
      </span>
            <input type="text"
                   class="form-control"
                   placeholder="Lookup a Person"
                   autocomplete="off"
                   v-model="query"
                   @input="search"/>
          </div>
        </div>
        <div class="col-sm-2"><a href="javascript:void(0)" v-if="showingResults" @click="clearResults()">Clear
          Results</a></div>
      </div>
      <div class="form-group">
        <div :class="resultClass">
          <transition name="fade" mode="out-in">
            <table class="table table-condensed table-striped" v-if="personResults && personResults.length > 0">
              <thead>
              <tr>
                <th width="10%" v-if="showSelect || showAdminEdit"></th>
                <th>Name</th>
                <th>
                  <div class="row">
                    <div class="col-sm-6">Current Institution(s)</div>
                    <div class="col-sm-6">Current Title(s)</div>
                  </div>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="person in personResults">
                <td v-if="showSelect">
                  <button type="button" class="btn btn-xs btn-default" @click="selectPerson(person)">Select</button>
                </td>
                <td v-if="showAdminEdit">
                  <button type="button" class="btn btn-xs btn-default" @click="selectPerson(person)">Edit</button>
                </td>
                <td>{{ person.firstName }} {{ person.middleInitial != null ? person.middleInitial : '' }}
                  {{ person.lastName }}
                </td>
                <!--<td></td>-->
                <td>
                  <div class="row" v-for="memberPersonOrg in person.memberPersonOrgs"
                       v-if="!memberPersonOrg.deleteFlag || memberPersonOrg.deleteFlag === 'N'">
                    <div class="col-sm-6" v-if="showSelect">{{ memberPersonOrg.memberOrg.nameOfficial }}</div>
                    <div class="col-sm-6" v-if="showContactCard">
                      <a href="javascript:void(0)" @click="contactCard(person.personId, memberPersonOrg.orgId)">
                        {{ memberPersonOrg.memberOrg.nameOfficial }}</a></div>
                    <div class="col-sm-6">
                      <p v-for="orgTitle in memberPersonOrg.memberPersonOrgTitles"
                         v-if="(!orgTitle.deleteFlag || orgTitle.deleteFlag === 'N')
                   && orgTitle.titleCode !== 'HC'">{{ orgTitle.memberTitle.description }}</p>
                      <p v-for="coachSport in memberPersonOrg.memberCoachSportDates"
                         v-if="!coachSport.deleteFlag || coachSport.deleteFlag === 'N'">Head Coach -
                        {{ coachSport.memberSport.description }}</p>
                    </div>
                  </div>
                </td>
                <td><a href="javascript:void(0)" v-if="hasHistory(person)" @click="showHistory(person)">Inst.
                  History</a></td>
              </tr>
              </tbody>
            </table>
            <p class="text-center" v-else-if="showingResults"><em>No results found.</em></p>
          </transition>
        </div>
      </div>
    </div>

    <div class="modal fade" id="history-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{ personHistory.firstName }} {{ personHistory.lastName }} Institution History</h4>
          </div>
          <div class="modal-body">
            <p><em>Note: Institution history is not listed in chronological order.</em></p>
            <table class="table table-condensed table-striped">
              <thead>
              <tr>
                <th class="col-sm-6">Institution</th>
                <th class="col-sm-6">Title(s)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="memberPersonOrg in personHistory.memberPersonOrgs" v-if="memberPersonOrg.deleteFlag === 'Y'">
                <td class="col-sm-6">{{ memberPersonOrg.memberOrg.nameOfficial }}</td>
                <td class="col-sm-6">
                  <p v-for="orgTitle in memberPersonOrg.memberPersonOrgTitles"
                     v-if="orgTitle.titleCode !== 'HC'">{{ orgTitle.memberTitle.description }}</p>
                  <p v-for="coachSport in memberPersonOrg.memberCoachSportDates">Head Coach -
                    {{ coachSport.memberSport.description }}</p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </section>
</template>

<script>
import PersonService from '../endpoints/PersonService'
import {debounce} from 'lodash'
import * as axios from 'axios'
import $ from 'jquery'

export default {
  props: {
    showSelect: {
      type: Boolean,
      default: true
    },
    showContactCard: {
      type: Boolean,
      default: false
    },
    showAdminEdit: {
      type: Boolean,
      default: false
    },
    searchClass: {
      type: String,
      default: 'col-sm-8 col-sm-offset-2'
    },
    resultClass: {
      type: String,
      default: 'col-sm-10 col-sm-offset-1'
    }
  },
  data() {
    return {
      query: '',
      personResults: [],
      minChars: 3,
      error: '',
      loading: false,
      showingResults: false,
      cancelSource: null,
      personHistory: {}
    }
  },
  methods: {
    search: debounce(function search() {
      let self = this
      if (this.cancelSource) {
        this.cancelSource.cancel()
      }

      if (!this.query || (this.minChars && this.query.length < this.minChars)) {
        this.showingResults = false
        self.personResults = []
        return
      }

      let CancelToken = axios.CancelToken
      this.cancelSource = CancelToken.source()

      this.loading = true

      PersonService.searchPerson(this.query, this.cancelSource)
        .then(response => {
          self.personResults = response.data
          self.cancelSource = null
          this.loading = false
          this.showingResults = true
        })
        .catch(error => {
          self.error = error.message
          this.loading = false
        })
    }, 500),
    clearResults: function () {
      this.personResults = []
      this.query = ''
      this.showingResults = false
    },
    selectPerson: function (person) {
      this.$emit('select-person', person)
    },
    contactCard: function (personId, orgId) {
      let params = {
        personId: personId,
        orgId: orgId
      }
      this.$emit('show-contact', params)
    },
    showHistory: function (person) {
      this.personHistory = person
      $('#history-modal').modal('show')
    },
    hasHistory: function (person) {
      for (let i = 0; i < person.memberPersonOrgs.length; i++) {
        if (person.memberPersonOrgs[i].deleteFlag && person.memberPersonOrgs[i].deleteFlag === 'Y') {
          return true
        }
      }

      return false
    }
  },
  watch: {
    showingResults: function (val) {
      this.$emit('show-results', val)
    }
  }
}
</script>

<style>
.glyphicons-refresh-animate {
  -animation: spin .7s infinite linear;
  -webkit-animation: spin2 .7s infinite linear;
}

@-webkit-keyframes spin2 {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: scale(1) rotate(0deg);
  }
  to {
    transform: scale(1) rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/js/components/PersonLookupComponent.vue